<template>
  <div
    class="border-t pt-1 bg-center bg-cover h-full bg-[url(/src/assets/images/preview-pattern.svg)]"></div>
</template>
<script setup lang="ts"></script>
